<div class="modal-header">
  <h5
    class="modal-title"
    i18n="@@edit-projectsecret"
  >Secret bearbeiten</h5>
  <p-button
    type="button"
    severity="secondary"
    [text]="true"
    [rounded]="true"
    icon="ri-close-fill ri-xl"
    (onClick)="this.cancel()"
  ></p-button>
</div>
<div class="modal-body">
  <div class="row mb-1 align-items-center">
    <div class="col-3">
      <span i18n="@@name-label">Name:</span>
    </div>
    <div class="col">
      <input
        pInputText
        pSize="small"
        fluid
        type="text"
        [(ngModel)]="this.name"
      >
    </div>
  </div>
  <div class="row mb-1 align-items-center">
    <div class="col-3">
      <span i18n="@@projectsecret-description">Beschreibung</span>
    </div>
    <div class="col">
      <input
        pInputText
        pSize="small"
        fluid
        type="text"
        [(ngModel)]="this.description"
      >
    </div>
  </div>

  <div class="row align-items-center">
    <div class="col-3">
      <span i18n="@@projectsecret-secretupdate">Secret aktualisieren</span>
      <p-toggleswitch
        [(ngModel)]="this.secretShouldBeUpdated"
        (onChange)="this.secretUpdateSelectChanged()"
      ></p-toggleswitch>
    </div>

    <div class="col">
      <input
        [disabled]="!this.secretShouldBeUpdated"
        pInputText
        pSize="small"
        fluid
        type="text"
        [(ngModel)]="this.secret"
      >
    </div>
  </div>
</div>

<div class="modal-footer">
  <p-button
    type="button"
    severity="primary"
    label="Speichern"
    i18n-label="@@save"
    (onClick)="this.update()"
    [disabled]="this.checkInput()"
  ></p-button>
</div>